import { Suspense } from "react";
import { Provider } from "react-redux";
import { Switch, BrowserRouter } from "react-router-dom";
import {
  initializeSession,
  registerStore,
  ConfigurationContextProvider,
  writeLocalStorage,
  Loader,
} from "lcm-iot-commons";

import { CompatRouter } from "react-router-dom-v5-compat";
import ErrorBoundary from "lcm-iot-commons/client/lib/components/Errors/ErrorBoundary";
import Intl from "lcm-iot-commons/client/lib/components/Intl";
import configureStore from "../store/configureStore";
import Routes from "./Routes";
import SsoRoutes from "./SsoRoutes";
import * as AppRoot from "../containers/Root";
import SsoRoot from "../containers/SsoRoot";

import "react-widgets/lib/scss/react-widgets.scss";
import "../assets/styles/main.scss";
import { mergeAppMessages } from "../translations";

require("../rules");

// @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
const store = configureStore();
registerStore(store);

type RootAppProps = {
  initialization: {
    configuration?: {
      appName?: string;
      lcmApiUrl?: string;
      backendApiUrl?: string;
      loginOnly?: boolean;
    };
    session?: {
      token?: string;
    };
  };
};

function RootApp(props: RootAppProps) {
  const { initialization } = props;
  const { configuration = {}, session } = initialization;

  const rootBackUrl = `${window.location.origin}/app/id`;
  writeLocalStorage("rootBackUrl", rootBackUrl);

  // FIXME: FALLBACK for old code don't use it!
  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  global.configuration = configuration;
  store.dispatch(initializeSession(session));

  const Root = configuration.loginOnly ? SsoRoot : AppRoot.default;

  return (
    <Suspense fallback={<Loader />}>
      <Intl mergeAppMessages={mergeAppMessages}>
        {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element; isFullPage: true; }' is... Remove this comment to see the full error message */}
        <ErrorBoundary isFullPage>
          <ConfigurationContextProvider configuration={configuration}>
            <Provider store={store}>
              <BrowserRouter>
                <CompatRouter>
                  <Switch>
                    <Root>
                      <Switch>
                        {configuration.loginOnly ? <SsoRoutes /> : <Routes />}
                      </Switch>
                    </Root>
                  </Switch>
                </CompatRouter>
              </BrowserRouter>
            </Provider>
          </ConfigurationContextProvider>
        </ErrorBoundary>
      </Intl>
    </Suspense>
  );
}

(window as $TSFixMe).app = {
  store,
};

const App =
  (props: $TSFixMe, railsContext: $TSFixMe) =>
  // eslint-disable-next-line
  () => <RootApp {...{ ...props, railsContext }} />;

export default App;

export { RootApp };
